/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tableheaders_Createdat2Inputs */

const id_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat Pada`)
};

const ms_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicipta Pada`)
};

const da_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettet`)
};

const de_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const en_us2_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const es_es2_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

const es_mx2_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado`)
};

const fil_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginawa Noong`)
};

const fr_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé le`)
};

const it_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data creazione`)
};

const hu_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozva`)
};

const nl_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangemaakt op`)
};

const no_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettet`)
};

const pl_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utworzono`)
};

const pt_br2_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

const pt_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

const ro_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creat la`)
};

const fi_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luotu`)
};

const sv_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapad`)
};

const vi_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

const tr_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma`)
};

const cs_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno`)
};

const bg_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Създадено`)
};

const ru_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано`)
};

const uk_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створено`)
};

const ar_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण तिथि`)
};

const th_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างเมื่อ`)
};

const ja_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建日期`)
};

const zh_hant1_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立日期`)
};

const ko_home_tableheaders_createdat2 = /** @type {(inputs: Home_Tableheaders_Createdat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성일`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Home_Tableheaders_Createdat2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_tableheaders_createdat2 = /** @type {((inputs?: Home_Tableheaders_Createdat2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tableheaders_Createdat2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_tableheaders_createdat2(inputs)
	if (locale === "ms") return ms_home_tableheaders_createdat2(inputs)
	if (locale === "da") return da_home_tableheaders_createdat2(inputs)
	if (locale === "de") return de_home_tableheaders_createdat2(inputs)
	if (locale === "en-US") return en_us2_home_tableheaders_createdat2(inputs)
	if (locale === "es-ES") return es_es2_home_tableheaders_createdat2(inputs)
	if (locale === "es-MX") return es_mx2_home_tableheaders_createdat2(inputs)
	if (locale === "fil") return fil_home_tableheaders_createdat2(inputs)
	if (locale === "fr") return fr_home_tableheaders_createdat2(inputs)
	if (locale === "it") return it_home_tableheaders_createdat2(inputs)
	if (locale === "hu") return hu_home_tableheaders_createdat2(inputs)
	if (locale === "nl") return nl_home_tableheaders_createdat2(inputs)
	if (locale === "no") return no_home_tableheaders_createdat2(inputs)
	if (locale === "pl") return pl_home_tableheaders_createdat2(inputs)
	if (locale === "pt-BR") return pt_br2_home_tableheaders_createdat2(inputs)
	if (locale === "pt") return pt_home_tableheaders_createdat2(inputs)
	if (locale === "ro") return ro_home_tableheaders_createdat2(inputs)
	if (locale === "fi") return fi_home_tableheaders_createdat2(inputs)
	if (locale === "sv") return sv_home_tableheaders_createdat2(inputs)
	if (locale === "vi") return vi_home_tableheaders_createdat2(inputs)
	if (locale === "tr") return tr_home_tableheaders_createdat2(inputs)
	if (locale === "cs") return cs_home_tableheaders_createdat2(inputs)
	if (locale === "bg") return bg_home_tableheaders_createdat2(inputs)
	if (locale === "ru") return ru_home_tableheaders_createdat2(inputs)
	if (locale === "uk") return uk_home_tableheaders_createdat2(inputs)
	if (locale === "ar") return ar_home_tableheaders_createdat2(inputs)
	if (locale === "hi") return hi_home_tableheaders_createdat2(inputs)
	if (locale === "th") return th_home_tableheaders_createdat2(inputs)
	if (locale === "ja") return ja_home_tableheaders_createdat2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_tableheaders_createdat2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_tableheaders_createdat2(inputs)
	return ko_home_tableheaders_createdat2(inputs)
});
export { home_tableheaders_createdat2 as "home.tableHeaders.createdAt" }